<template>
  <footer class="tw-flex tw-justify-end tw-text-[#b3b9c6]">
    <!-- <div>Client Logo</div> -->
    <div>
      <span class="tw-font-poppins">Presented by</span>
      <span class="tw-font-georgia">{{ advisorStore.advisor?.firm.name }}</span>
    </div>
  </footer>
</template>


<script>
import { mapStores } from 'pinia';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';

export default {
  name: 'ComponentName',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  computed: { ...mapStores(useAdvisorStore) },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  methods: {},
};
</script>
